<template>
  <div>
    <CreateSpecUpdateDialog
      :dialog="showCreateSpecUpdateDialog"
      :tmpPath="tmpPath"
      :manfiest="manifest"
      @close="closeCreateSpecUpdateDialog"
    >
    </CreateSpecUpdateDialog>

    <UploadSpecUpdateDialog
      :dialog="showUploadSpecUpdateDialog"
      @close="closeUploadSpecUpdateDialog"
    >
    </UploadSpecUpdateDialog>

    <v-card height="775px" style="position:relative;padding-bottom:50px">
      <v-toolbar
        color="grey darken-3"
        dark
        flat
      >
        <v-toolbar-title>Specifications</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            align-with-title
            background-color="transparent"
            grow
          >
            <v-tabs-slider color="red"></v-tabs-slider>

            <v-tab>Statistics</v-tab>
            <v-tab>Spec Releases</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <InstalledSpecs />
        </v-tab-item>
        <v-tab-item>
          <Specs ref="specsComponent"/>
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <DropZone
          v-if="tab === 1 && canShowCreateSpecUpdate"
          :file="uploadedFile"
          :progress="uploadProgress"
          :is-uploading="isUploading"
          @file-selected="handleFileSelected"
          @file-removed="handleFileRemoved"
        />
        <v-btn
          color="grey lighten-1"
          @click.stop="openCreateSpecUpdateDialog()"
          v-if="tab === 1 && canShowCreateSpecUpdate"
        >
          Create Spec Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import InstalledSpecs from '../components/spec_updates/SpecsChart.vue';
import CreateSpecUpdateDialog from '../components/spec_updates/CreateSpecUpdateDialog.vue';
import Specs from '../components/spec_updates/Specs.vue';
import ConfirmDialog from "../components/ConfirmDialog.vue";
import DropZone from '@/components/DropZone.vue';
import axios from 'axios';
import UploadSpecUpdateDialog from '@/components/spec_updates/UploadSpecUpdateDialog.vue';

export default {
  components: {
    UploadSpecUpdateDialog,
    DropZone,
    CreateSpecUpdateDialog,
    InstalledSpecs,
    Specs,
  },

  data() {
    return {
      tab: 0,
      showCreateSpecUpdateDialog: false,

      // added for file upload
      uploadedFile: null,
      uploadProgress: 0,
      isUploading: false,
      showUploadSpecUpdateDialog: false,
      tmpPath: null,
      manifest: null,
    };
  },

  computed: {
    canShowCreateSpecUpdate() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin' ||
          this.$store.state.auth.token.user.role === 'engineer'
        )
      );
    },
  },

  methods: {
    openCreateSpecUpdateDialog() {
      this.showCreateSpecUpdateDialog = true;
    },

    closeCreateSpecUpdateDialog(newSpecUpdateCreated) {
      this.showCreateSpecUpdateDialog = false;
      if (newSpecUpdateCreated) {
        this.$refs.specsComponent.getData();
      }
    },

    // added for file upload
    closeUploadSpecUpdateDialog(newSpecUpdateCreated) {
      this.showUploadSpecUpdateDialog = false;
      if (newSpecUpdateCreated) {
        this.$refs.specsComponent.getData();
      }
    },
    handleFileSelected(file) {
      this.uploadedFile = file;
      this.uploadFileToBackend(file);
    },
    handleFileRemoved() {
      this.uploadedFile = null;
      this.uploadProgress = 0;
      this.isUploading = false;
    },
    async uploadFileToBackend(file) {
      this.isUploading = true;
      this.uploadProgress = 0;

      // Prepare multi-part form payload
      const formData = new FormData();
      formData.append('tarFile', file); // 'tarFile' matches req.files.tarFile on Express

      try {
        console.log('posting to upload_spec_update');

        const response = await axios.post('/upload_spec_update', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          // Native Axios progress callback calculation
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          }
        });

        if (response.status === 200) {
          console.log(`response.data=${JSON.stringify(response.data)}`);

          this.tmpPath = response.data.tmpPath;
          this.manifest = response.data.manifest;

          this.showUploadSpecUpdateDialog = true;
        } else {
          alert('Failed to upload file!');
        }
      } catch (error) {
        // Fallback checks to safely extract error text sent from Express
        this.uploadProgress = 0; // Reset progress bar if upload failed
      } finally {
        this.tmpPath = null;
        this.manifest = null;
        this.isUploading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
